import { CommonService } from './../../services/common.service';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { InnerPagesService } from './../../services/inner-pages.service';
import { AgencyModel } from 'src/app/models/Common/AgencyModel';
import { ContactModel } from 'src/app/models/Common/ContactModel';
// import { ContactUsModel } from 'src/app/models/Common/ContactUsModel';
import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import { SearchCountryField, TooltipLabel, CountryISO } from 'ngx-intl-tel-input';

@Component({
  selector: 'app-contact-us',
  templateUrl: './contact-us.component.html',
  styleUrls: ['./contact-us.component.css']
})
export class ContactUsComponent implements OnInit {

  faTimesCircle=faTimesCircle;
  lat = 51.678418;
  lng = 7.809007;
  Branches;
  messageContent: ContactModel;
  showConfirm = false;
  subbmited:boolean;
  separateDialCode = false;
	SearchCountryField = SearchCountryField;
	CountryISO = CountryISO;
	preferredCountries: CountryISO[] = [CountryISO.UnitedStates, CountryISO.UnitedKingdom];
  selectedCountryISO = CountryISO.UnitedStates;



  form = new FormGroup({
    name: new FormControl('', Validators.required),
    email: new FormControl('', [
      Validators.required,
      Validators.email,
      Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$"),
    ]),
    mobileNumber: new FormControl('', Validators.required),
    message: new FormControl('', Validators.required)
  });
  agencies: AgencyModel[];

  constructor(private innesrPageService: InnerPagesService,private commonService:CommonService) {

  }

  ngOnInit() {
    this.commonService.getAgencies().subscribe(res =>{
      this.agencies=res;
      if(res!=null){
        this.lat=res[0].latitude;
        this.lng=res[0].longitude;
      }
    })
  }

  mobileNumCountryCodeChanged(){
    this.form.controls['mobileNumber'].setValue(null);
  }

  onSubmit(){
    //alert(JSON.stringify(messageContent));
    this.subbmited = true;

    //custom Validation for Mobile number, Incase it have spaces
    let countryControlVal=this.form.controls.mobileNumber.value;
    if(countryControlVal!=null&&countryControlVal.number.includes(' ')){
        this.form.controls.mobileNumber.setErrors({'InvalidSpace':'invalidPhoneNumber'});
        //this.form.controls.mobileNumber.updateValueAndValidity();
        return;
    }
    if(countryControlVal!=null&&!countryControlVal.number.includes(countryControlVal.dialCode)){
      this.form.controls.mobileNumber.setErrors({'RequiredCountryCode':'invalidPhoneNumber'});
      //this.form.controls.mobileNumber.updateValueAndValidity();
      return;
    }





    if(this.form.valid){
      ;
      let _messageContent:ContactModel={};

     _messageContent.name = this.form.controls.name.value;
     _messageContent.email =  this.form.controls.email.value;
     _messageContent.mobileNumber = this.form.controls.mobileNumber.value.number;
     _messageContent.message = this.form.controls.message.value;
      this.commonService.onContactUs(_messageContent).subscribe(response => {
        ;
        this.showConfirm = true;
        }, error => {

        });
    }


  }




}
